'use strict';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../actions';
import Select from './Select';
import InlineAlert from './InlineAlert';
import Dropdown from './Dropdown';
import _ from 'lodash';

import './../../scss/components/_corporation.scss';
import './../../scss/main.scss';
import './../../scss/_icons.scss';

export class Corporation extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.dropDownChanged = this.dropDownChanged.bind(this);
		this.preventRedirect = this.preventRedirect.bind(this);

		this.state = {
			selectedValue: '',
		};
	}

	dropDownChanged(value) {
		var corp = {
			id: this.props.corporation.id,
			feedId: value,
		};

		this.setState({
			selectedValue: value,
		});

		this.props.actions.editCorporation(corp);
	}

	preventRedirect(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	handleClick(e) {
		if (e.isDefaultPrevented()) {
			this.preventRedirect(e);
		}
	}

	render() {
		/* Selected */
		let selectedValue = this.state.selectedValue;
		let feeds = _.map(this.props.corporation.feeds, f => {
			if (
				selectedValue.length <= 0 &&
				parseInt(f.id) === parseInt(this.props.corporation.feedId)
			) {
				selectedValue = f.id;
			}
			return {
				isHighlighted: false,
				isSelected: false,
				label: f.name,
				value: f.id,
			};
		});

		return (
			<div className="row table-row corporation hover" onClick={this.props.onClick}>
				<div className="cell table-cell">
					<div>
						<div>
							<strong>{this.props.corporation.name}</strong>
						</div>
						<div className="santas-gray">Corporation ID: {this.props.corporation.id}</div>
						<div className="santas-gray">#{this.props.corporation.number}</div>
						{this.props.corporation.paidBuilderId && (
							<div className="santas-gray">
								Paid Builder ID: {this.props.corporation.paidBuilderId}
							</div>
						)}
						{this.props.corporation.ssid && (
							<div className="santas-gray">SSID: {this.props.corporation.ssid}</div>
						)}
					</div>
				</div>

				<div className="cell table-cell">
					<div className="stat-titles">
						<div>Total Divisions</div>
						<div>Communities Paid</div>
					</div>
					<div className="stats">
						<div>{this.props.corporation.builderCount}</div>
						<div>
							{this.props.corporation.enabledSubdivisionCount}/
							{this.props.corporation.subdivisionCount}
						</div>
					</div>
				</div>

				<div className="cell table-cell dropdown-cell" onClick={this.handleClick}>
					<Choose>
						<When condition={feeds.length > 1}>
							<Dropdown
								wrap
								name="corporationFeeds"
								options={feeds}
								multiple={false}
								value={selectedValue}
								selected={selectedValue}
								onChange={this.dropDownChanged}
							/>
						</When>
						<When condition={feeds.length === 1}>
							<label htmlFor="corporationFeeds">{feeds[0].label || '\u00a0'}</label>
						</When>
					</Choose>
					{this.props.updatedCorporationId == this.props.corporation.id ? (
						<InlineAlert success={true} />
					) : (
						''
					)}
				</div>
			</div>
		);
	}
}

Corporation.propTypes = {
	corporation: PropTypes.object.isRequired,
};

export default connect(
	state => {
		return {
			error: state.corporations.error,
			isFetching: state.corporations.isFetching,
			updatedCorporationId: state.corporations.updatedCorporationId,
		};
	},
	dispatch => {
		return {
			actions: bindActionCreators(actions.corporations, dispatch),
		};
	},
)(Corporation);



// WEBPACK FOOTER //
// ./src/assets/js/components/Corporation.js